import React from 'react';
import { IconProps } from '../IconProps';
const SvgMicrophoneSlash = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M20.667 12L13.5 19.515a6.668 6.668 0 01-4.167-6.182V8a6.667 6.667 0 1113.334 0v2.667l-2 1.333z"
      fill={primaryColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.667 13.333a9.322 9.322 0 004.084 7.719l-1.502 2.204A11.989 11.989 0 014 13.333h2.667zM28 12v1.333c0 6.628-5.373 12-12 12h-1.334v-2.666H16a9.333 9.333 0 009.333-9.334V12H28z"
      fill={primaryColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.333 22.667v8h-2.666v-8h2.666z"
      fill={primaryColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.333 28h13.334v2.667H9.333V28zM29.886 4L4 29.886 2.114 28 28 2.114 29.886 4z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgMicrophoneSlash;
